import { Box, Typography } from '@material-ui/core'
import { useCallback, useEffect, useMemo, useState } from 'react'

import CommonTable from '@/components/common-table'
import Loading from '@/components/loading'
import { useGetFolders } from '@/hooks/queries/use-get-folders'

import { useStyles } from './styles'

interface FoldersListProps {
  tab: 'byownerid' | 'byuserid'
  searchFolder: string
}

export const FoldersList = ({ tab, searchFolder }: FoldersListProps) => {
  const classes = useStyles()

  const [feedbackMessage, setFeedbackMessage] = useState({
    title: '',
    description: '',
  })

  const handleErrorMessage = useCallback(setFeedbackMessage, [])

  const { data, isLoading, isSuccess } = useGetFolders(tab, handleErrorMessage)

  const filteredFolders = useMemo(() => {
    const filteredList = data?.filter(
      (folder) =>
        folder.name.toLowerCase().includes(searchFolder.toLowerCase()) ||
        folder.description.toLowerCase().includes(searchFolder.toLowerCase()),
    )

    return filteredList || []
  }, [data, searchFolder])

  useEffect(() => {
    if (isSuccess && !filteredFolders.length) {
      setFeedbackMessage({
        title: 'Nenhuma pasta cadastrada.',
        description: 'Adicione uma nova pasta.',
      })
    }
  }, [filteredFolders, isSuccess])

  if (isLoading) return <Loading className={classes.loading} />

  if (isSuccess && filteredFolders.length)
    return (
      <CommonTable
        className={classes.foldersTable}
        headers={['Nome', 'Descrição', 'Última Atualização']}
        proportions='4fr 7fr 2fr 2fr'
        cellBorders='1px 0px 0px 0px'
        cellBorderColor='#DDD'
        cellBorderStyle='solid'
        contentVariants={['body2']}
        alignVariants={['left', 'left', 'center']}
        rows={filteredFolders.map(Object.values)}
      />
    )

  return (
    <Box className={classes.errorMessage}>
      <Typography variant={'body2'}>{feedbackMessage.title}</Typography>
      <Typography variant={'body1'}>{feedbackMessage.description}</Typography>
    </Box>
  )
}
